import { useDispatch } from 'react-redux';

import { exportLocationsInventory } from '../../../../../../store/inventory/inventory.actions';

/**
 * Custom hook that provides a function to export inventory locations to CSV using Redux
 * @param {string} inventoryWarehouseId - The ID of the inventory warehouse
 * @returns {() => void} A function that exports locations to CSV
 */
export const useExportLocationsCSV = (inventoryWarehouseId) => {
  const dispatch = useDispatch();

  return () => {
    if (!inventoryWarehouseId) {
      return;
    }

    dispatch(
      exportLocationsInventory({
        inventoryWarehouseId,
      }),
    );
  };
};
